import React from 'react';
import { useTheme, Box, Typography } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';

const LineChart = ({ 
  data = [], 
  fieldName, 
  title = "",
  bottomLegend, 
  leftLegend, 
  isHorizontalBottomLegend, 
  topOffSet = 0,
  bottomOffSet = 0,
  bottomLegendOffSet = 0, 
  itemWidthOffSet = 0, 
  translateXOffSet = 0,
  translateYOffSet = 0,
  itemsSpacingOffSet = 0,
}) => {
  const theme = useTheme();
  const neutralDark = theme.palette.neutral.dark;
  const textPrimaryColor = theme.palette.text.primary;

  if (!data || data.length === 0 || !Array.isArray(data)) {
    return (
      <Box p={1} sx={{ height: '100%', width: '100%' }}>        
        <Typography>Nothing to display</Typography>
      </Box>
    );
  }

  const calculateMinMax = (data) => {
    let minY = Infinity;
    let maxY = -Infinity;

    data.forEach(series => {
      series.data.forEach(point => {
        if (point.y < minY) minY = point.y;
        if (point.y > maxY) maxY = point.y;
      });
    });

    switch (fieldName) {
      case 'btDiff':
        minY = minY - 2;
        break;
      default:
        minY = minY - 2 > 0 ? minY - 2 : 0;
        maxY = maxY + 2;
      break;
    }    

    return { minY, maxY };
  };
  const { minY, maxY } = calculateMinMax(data);


  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      {title && 
        <Typography 
          variant="h6" 
          align="center"
        >
          {title}
        </Typography>
      }

      <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
        <ResponsiveLine
          data={data}       
          margin={{
            top: 25 + topOffSet,
            right: 20, 
            bottom: 155 + bottomOffSet, 
            left: 80 
          }}
          xScale={{ type: 'point' }}
          yScale={{
            type: 'linear',
            min: minY,
            max: maxY,
            stacked: false,
            reverse: false
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 45 + bottomLegendOffSet,
            tickRotation: isHorizontalBottomLegend ? 0 : 270,
            legend: bottomLegend,
            legendOffset: 75 + bottomLegendOffSet,
            legendPosition: 'middle',
            truncateTickAt: 0
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: leftLegend || 'Value',
            legendOffset: -60,
            legendPosition: 'middle',
          }}
          colors={d => d.color || 'defaultColor'}
          lineWidth={2}
          pointSize={6}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor="#8bd086"
          enablePointLabel={true}
          pointLabel="data.y"
          pointLabelYOffset={-12}
          enableTouchCrosshair={true}
          useMesh={true}
          legends={[
            {
              anchor: 'top-right',
              direction: 'row',
              justify: false,
              translateX: 10 + translateXOffSet,
              translateY: -30 + translateYOffSet,
              itemsSpacing: 10 + itemsSpacingOffSet,
              itemDirection: 'left-to-right',
              itemWidth: 80 + itemWidthOffSet,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: 'circle',
              symbolBorderColor: 'rgba(0, 0, 0, .5)',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemBackground: 'rgba(0, 0, 0, .03)',
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
          theme={{
            axis: {
              domain: {
                line: {
                  stroke: neutralDark,
                },
              },
              legend: {
                text: {
                  fill: textPrimaryColor,
                },
              },
              ticks: {
                line: {
                  stroke: textPrimaryColor,
                  strokeWidth: 1,
                },
                text: {
                  fill: textPrimaryColor,
                },
              },
            },
            legends: {
              text: {
                fill: textPrimaryColor,
              },
            },
            grid: {
              line: {
                stroke: neutralDark,
                strokeWidth: 0.2,
                strokeDasharray: '2 2'
              }
            },
            tooltip: {
              container: {
                background: theme.palette.neutral.light,
                color: theme.palette.text.primary,
                borderRadius: '4px',
                padding: '8px',
              },
            },          
            dots: {
              text: {
                fill: textPrimaryColor,
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default LineChart;
